import { cva } from 'class-variance-authority';

export const linkVariants = cva('', {
  variants: {
    variant: {
      default:
        'text-dp-blue-800 text-base hover:text-dp-blue-800 focus:text-dp-blue-800 active:text-dp-blue-800',
      footerLink:
        'text-sm text-dp-dark-400 hover:text-dp-dark-400 focus:text-dp-dark-400 active:text-dp-dark-400',
      unstyled: 'block no-underline',
    },
  },
  defaultVariants: { variant: 'default' },
});
